import "./AboutSection.scss";
import { HandLogo, TwitterIcon, TelegramIcon } from "@images";
import { Button, Col, Row } from "antd";

interface iPropos {
  isMobile: boolean;
}

function AboutSection(props: iPropos) {
  const { isMobile } = props;

  return (
    <>
      <div className="about-container">
        {isMobile && <div className="social-buttons">
          <Button type="primary" shape="circle" className="social-btn">
            <img src={TwitterIcon} alt="" />
          </Button>
          <Button type="primary" shape="circle" className="social-btn">
            <img src={TelegramIcon} alt="" />
          </Button>
        </div>}

        <Row gutter={20} justify="center">
          <Col span={2} md={2} xl={2} xxl={2} xs={6} className="text-center">
            <div className="hand-logo">
              <img src={HandLogo} alt="" />
            </div>
          </Col>
          <Col span={8} md={8} xl={8} xxl={8} xs={8}>
            <h3 className="heading">About us</h3>
            <h3 className="heading">FAQs</h3>
          </Col>
          <Col span={8} md={8} xl={8} xxl={8} xs={10}>
            <h3 className="heading">Terms & condition</h3>
            <h3 className="heading">Privacy policy</h3>
          </Col>
          {!isMobile && (
            <Col span={6} md={6} xl={6} xxl={3} xs={3} className="text-right">
              <Button type="primary" shape="circle" className="social-btn">
                <img src={TwitterIcon} alt="" />
              </Button>
              <Button type="primary" shape="circle" className="social-btn">
                <img src={TelegramIcon} alt="" />
              </Button>
            </Col>
          )}
        </Row>
      </div>
    </>
  );
}
export default AboutSection;
